export {
    default as TemplateDashboard,
    ITemplateDashboardProps,
    ITemplateDashboardCardHeaderProps,
    ITemplateDashboardFeedbackProps,
    ITemplateDashboardQuestionsProps,
    ITemplateDashboardHeatmapProps,
} from './dashboard';
